<div class="dialog-container" [class.edit-mode]="isEditMode">
  @if (!isEditMode) {
  <div class="dialog-header">
    <h2 class="dialog-title">نوع تقييم جديد</h2>
    <p class="dialog-subtitle">عرض خيارات المقياس وقيمها والوانها</p>
  </div>
}

  <div class="main-content" mat-dialog-content>
    <div class="form-group">
      <label class="form-label">{{ data.label }}</label>
      <input
        type="text"
        [(ngModel)]="data.textValue"
        class="form-control"
        [placeholder]="data.placeholder"
        [readonly]="isEditMode"
        [class.readonly-field]="isEditMode"
      />
    </div>

    @if (isEditMode) {
    <div class="edit-notice">
      <span>غير ألوان الخيارات كما تظهر في التقارير. الأسماء والقيم ثابتة للحفاظ على دقة التقارير السابقة</span>
    </div>
    }

    <div class="choices-section">
      <h3 *ngIf="!isEditMode" class="choices-label">الخيارات</h3>
      <div class="choices-header-wrapper">
        <div class="choices-header">
          <span class="col-name">التسمية</span>
          <span class="col-value">القيمة</span>
          <span class="col-color">اللون</span>
          @if (isEditMode) {
          <span class="col-preview m-edit">المعاينة</span>
          }
        </div>
        @if (!isEditMode) {
        <span class="col-delete"></span>
        }
      </div>

      <form [formGroup]="completionStatusForm">
        <div formArrayName="items">
          @for (item of status().controls; track item; let i = $index) {
          <div class="choice-row" [formGroupName]="i">
            <div class="name-cell">
              @if (isEditMode) {
              <span class="row-index">{{ i + 1 }}</span>
              }
              <input
                type="text"
                class="form-control name-input"
                formControlName="name"
                placeholder="اسم الخيار"
                [readonly]="isEditMode"
                [class.readonly-field]="isEditMode"
              />
            </div>
            <input
              type="number"
              class="form-control value-input"
              formControlName="value"
              placeholder="0"
              [readonly]="isEditMode"
              [class.readonly-field]="isEditMode"
            />
            <div class="color-wrapper" [style.width]="getColorWrapperWidth(i)">
              <span class="color-swatch" [style.background-color]="getSelectedColor(i)"></span>
              <mat-select
                formControlName="color"
                class="color-select"
                panelClass="completion-color-panel"
                [panelWidth]="getColorWrapperWidth(i)"
              >
                @if (!item.get('color')?.value) {
                <mat-option value="">
                  <span class="color-option-content">
                    <span class="color-option-label">اسم اللون</span>
                  </span>
                </mat-option>
                }

                @for (c of colorPalette; track c.id) {
                <mat-option [value]="c.color">
                  <span class="color-option-content">
                    <span class="color-option-swatch" [style.background-color]="c.color"></span>
                    <span class="color-option-label">{{ c.color_name }}</span>
                  </span>
                </mat-option>
                }
              </mat-select>
            </div>
            @if (isEditMode) {
            <span class="preview-cell">
              <span class="preview-label">التقرير:</span>
              <span class="preview-badge" [style.background-color]="getSelectedColor(i)">
                {{ item.get('name')?.value }}
              </span>
            </span>
            }
            @if (!isEditMode) {
            <button type="button" class="btn btn-delete" (click)="deleteItem(i)">
              <img alt="delete" src="assets/images/svg/DELETE1.svg" />
            </button>
            }
          </div>
          }
        </div>
      </form>

      @if (valueSumError) {
      <p class="value-sum-error">مجموع القيم ({{ totalValue }}) يجب أن يساوي 100</p>
      }

      @if (!isEditMode) {
      <button type="button" class="btn-add-choice" (click)="addItem()">
        <img alt="" src="assets/images/svg/add-icon-blue.svg" />
        <span>إضافة خيار</span>
      </button>
      }

    </div>
  </div>

  <div mat-dialog-actions class="setup-footer actions-double">
    <button class="btn-cancel" type="button" mat-dialog-close>إلغاء</button>
    <button
      class="btn-save"
      type="button"
      [disabled]="!canSave()"
      (click)="save()"
    >
      حفظ
    </button>
  </div>
</div>
